import { render, staticRenderFns } from "./TreeForMoving.vue?vue&type=template&id=6bbf4586"
import script from "./TreeForMoving.vue?vue&type=script&lang=js"
export * from "./TreeForMoving.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports